import { Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { IsDeviceOnlineService } from './services/is-online/is-online.service';
import { LocaleService } from './services/locale/locale.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  title = 'vam-frontend';
  subscriptions: Subscription[] = [];

  constructor(
    public translateService: TranslateService,
    public localeService: LocaleService,
    private readonly _isDeviceOnlineService: IsDeviceOnlineService
  ) {
    this.translateService.addLangs(['en', 'ar']);
    this.translateService.setDefaultLang('en');
  }

  ngOnInit() {
    this.localeService.localeSubject.subscribe((res) => {
      if (res) {
        this.translateService.use(res);
      }
    });

    this.subscriptions.push(this._isDeviceOnlineService.networkStatus$.subscribe());
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
